module.exports = __webpack_public_path__ + "static/media/avatar.80d6e3b9.svg";